require("././src/main.ts");


//////////////////
// WEBPACK FOOTER
// biz-ng-career-details (bower component)
// module id = 526
// module chunks = 0